import { useCallback, useMemo } from "react";
import { Select, SelectItem } from "@tremor/react";
import useHilosStore from "src/hooks/useHilosStore";
import i18n from "src/i18n";

const LANGUAGES = {
  en: "🇺🇸 English",
  es: "🇲🇽 Español",
  pt: "🇧🇷 Português",
};

const LangToggle = () => {
  const { language, changeLanguage } = i18n;
  const { updateSession } = useHilosStore();

  const normalizedLanguage = useMemo(() => {
    if (!language) return "en";
    const primaryLang = language.split("-")[0];
    return Object.keys(LANGUAGES).includes(primaryLang) ? primaryLang : "en";
  }, [language]);

  const handleChangeLanguage = useCallback(
    (newLang: string) => {
      changeLanguage(newLang);
      updateSession({
        default_language: newLang,
      });
    },
    [changeLanguage, updateSession]
  );

  if (!language) return null;

  return (
    <Select
      defaultValue={LANGUAGES[normalizedLanguage]}
      className="w-32"
      enableClear={false}
    >
      {Object.entries(LANGUAGES).map(([code, label]) => (
        <SelectItem
          key={code}
          value={label}
          onClick={() => handleChangeLanguage(code)}
        />
      ))}
    </Select>
  );
};

export default LangToggle;
